module.exports = __webpack_public_path__ + "static/img/about01.42bd63e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about01.jpg
// module id = 3nPg
// module chunks = 1